// extracted by mini-css-extract-plugin
export default {"container":"Arrecadacao_container__BU6HC","textContainer":"Arrecadacao_textContainer__nF+ry","errorMessage":"Arrecadacao_errorMessage__+40jf","button":"Arrecadacao_button__EzyMY"};